<div
  *ngIf="creditCard"
  class="payment-tile-container"
  [ngClass]="{'clickable': showRadio}"
  (click)="handleSelect()"
  (keyup.enter)="handleSelect()"
  tabindex="0"
>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex flex-row align-items-center">
      <img
        *ngIf="showRadio"
        [src]="getRadioPath"
        alt="Radio Icon"
        height="16"
        width="16"
        class="tile-radio"
      >
      <img *ngIf="creditCard?.cardTypeIconFilename"
        src="{{ '../../../../assets/svg/credit-cards/' + creditCard?.cardTypeIconFilename }}"
        alt="Visa Icon"
        width="38"
        class="card-type"
      >
      <div class="card-info">
        <div class="row no-gutters">
          <div class="col cardholder">
            {{ creditCard?.cardNickname? creditCard?.cardNickname: creditCard?.cardholderName }} / {{ creditCard?.cardAccount }}
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col"
            [ngClass]="{
              'exp-date': !creditCard?.expired,
              'exp-date-expired': creditCard?.expired
            }">
            {{!creditCard?.expired ? 'Expires' : 'Expired'}} on {{ creditCard?.expMonth | number:'2.0-0' }}/{{ creditCard?.expYear | number:'2.0-0' }}
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="!showRadio && !readOnly"
      class="d-flex flex-row"
    >
      <div
        class="tile-action"
        (click)="onEditPayment()"
        (keyup.enter)="onEditPayment()"
        tabindex="0"
      >
        <img
          src="../../../../assets/svg/ico_edit.svg"
          alt="Edit Icon"
          height="18"
          width="18"
        >
      </div>
      <div
        class="tile-action"
        (click)="onDeletePayment()"
        (keyup.enter)="onDeletePayment()"
        tabindex="0"
      >
        <img
          src="../../../../assets/svg/ico_trash_can.svg"
          alt="Delete Icon"
          height="20"
          width="15"
        >
      </div>
    </div>
    <div
      *ngIf="showChange"
      class="d-flex flex-row"
    >
      <div
        class="change-link"
        (click)="onChangePayment()"
        (keyup.enter)="onChangePayment()"
        tabindex="0"
      >
        Change
      </div>
    </div>

  </div>
</div>
